var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;

var react_1 = __importStar(require("react"));

var react_error_boundary_1 = require("react-error-boundary");

var isDevelopment = (process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development") === "development";
var isBrowser = typeof window !== "undefined";

var ErrorBoundary = function ErrorBoundary(_ref) {
  var children = _ref.children;
  return isBrowser ? react_1.default.createElement(react_error_boundary_1.ErrorBoundary, {
    fallbackRender: function fallbackRender(_ref2) {
      var error = _ref2.error,
          resetErrorBoundary = _ref2.resetErrorBoundary;
      return isDevelopment ? react_1.default.createElement("div", {
        role: "alert",
        style: {
          border: "3px #aaa dashed",
          padding: "1rem"
        }
      }, react_1.default.createElement("pre", null, react_1.default.createElement("strong", null, "\uD83D\uDC1B Component error")), react_1.default.createElement("pre", {
        style: {
          background: "#eee",
          marginTop: "1rem",
          padding: "1rem"
        }
      }, error.message), react_1.default.createElement("button", {
        onClick: resetErrorBoundary,
        style: {
          background: "black",
          color: "white",
          marginTop: "1rem",
          padding: "1rem"
        }
      }, "Reload Component")) : react_1.default.createElement(react_1.default.Fragment, null);
    },
    onError: function onError(error) {
      return console.error(error.message);
    }
  }, react_1.default.createElement(react_1.Suspense, {
    fallback: false
  }, children)) : react_1.default.createElement(react_1.default.Fragment, null, children);
};

exports.ErrorBoundary = ErrorBoundary;